import { combineReducers } from 'redux';
import qrcodeReducer from './qrcodeReducer';
import userReducer from './userReducer';

export default combineReducers({
    qrCodeReducer: qrcodeReducer,
    userReducer: userReducer
})